module.exports = __webpack_public_path__ + "static/img/bottom-dc-bg.f986eba5.png";